// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__20MoH","label":"Labeled_label__1tsfp","divider":"Labeled_divider__WUquF"};